module.exports = __webpack_public_path__ + "img/Icon awesome-facebook.7e916c52.svg";